import { render, staticRenderFns } from "./ImagesCatalog.vue?vue&type=template&id=5fb484d3&scoped=true&"
import script from "./ImagesCatalog.vue?vue&type=script&lang=js&"
export * from "./ImagesCatalog.vue?vue&type=script&lang=js&"
import style0 from "./ImagesCatalog.vue?vue&type=style&index=0&id=5fb484d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb484d3",
  null
  
)

export default component.exports